<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOnboarding } from './useOnboarding';

const { t } = useI18n();
const { interfaceMode, setInterfaceMode } = useOnboarding();

const selectedMode = computed({
  get: () => interfaceMode.value,
  set: val => setInterfaceMode(val),
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium text-n-slate-12">
      {{ t('ONBOARDING_TOUR.WELCOME.MODE_SELECTOR.TITLE') }}
    </label>
    <div class="flex gap-2">
      <button
        class="flex-1 py-2 px-3 rounded-lg border text-sm transition-all"
        :class="
          selectedMode === 'simple'
            ? 'border-n-brand bg-n-brand/10 text-n-brand'
            : 'border-n-weak text-n-slate-11 hover:bg-n-surface-3'
        "
        @click="selectedMode = 'simple'"
      >
        {{ t('ONBOARDING_TOUR.WELCOME.MODE_SELECTOR.SIMPLE') }}
      </button>
      <button
        class="flex-1 py-2 px-3 rounded-lg border text-sm transition-all"
        :class="
          selectedMode === 'expert'
            ? 'border-n-brand bg-n-brand/10 text-n-brand'
            : 'border-n-weak text-n-slate-11 hover:bg-n-surface-3'
        "
        @click="selectedMode = 'expert'"
      >
        {{ t('ONBOARDING_TOUR.WELCOME.MODE_SELECTOR.EXPERT') }}
      </button>
    </div>
  </div>
</template>
